module.exports = __webpack_public_path__ + "e5af07faf48db30dc7c87cf3a521799e.png";